import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error", "label"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Checkbox from './Checkbox';

// Styles
import './CheckboxField.scss';
var CheckboxField = function CheckboxField(_ref) {
  var error = _ref.error,
    label = _ref.label,
    input = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('CheckboxField', {
      error: !!error
    })
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: input.checked,
    onMouseDown: function onMouseDown() {
      return input.onChange(!input.checked);
    },
    error: !!error
  }), /*#__PURE__*/React.createElement("input", _extends({}, input, {
    id: input.name,
    type: "checkbox",
    className: classNames('checkbox-hidden-input')
  })), label);
};
CheckboxField.propTypes = {
  error: PropTypes.object,
  label: PropTypes.node
};
export default CheckboxField;